import { render, staticRenderFns } from "./DeliveryZoneList.vue?vue&type=template&id=10542d90"
import script from "./DeliveryZoneList.vue?vue&type=script&lang=js"
export * from "./DeliveryZoneList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports